module.exports = __webpack_public_path__ + "static/media/management-01.099e9512.png";